<style lang="less" scoped>
.max-height-table {
  max-height: 600px;
  overflow-y: auto;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">电表总表</div>
      <ZD-list-querys>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">所属电站</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="stationName"
                @change="stationNameChange"
                clearable
                filterable
               
                no-data-text="暂无数据"
              >
                <el-option
                  v-for="item in siteArr"
                  :key="item.stationNo"
                  :label="item.stationName"
                  :value="item.stationName"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div" style="width: 120px">
              电表名称或户号
            </div>
            <div class="query-inputs-div flex-1">
              <el-input
                size="small"
                v-model="queryInfo.elecName"
                placeholder="请输入电表名或户号"
                clearable
              ></el-input>
            </div>
          </div>
        </template>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">账单月份</div>
            <div class="query-inputs-div flex-1">
              <el-date-picker
                value-format="yyyy-MM"
                v-model="yearMon"
                style="width: 100%;"
                :picker-options="pickerOptions"
                type="month"
                placeholder="请选择自然月"
                size="small"
                @change="monthChange"
              >
              </el-date-picker>
            </div>
          </div>
        </template>
        <template slot="actions">
          <button
            class="common-bg-button"
            @click="getListData(pagination, true)"
          >
            搜 索
          </button>
          <button class="common-empty-button" @click="reset()">重 置</button>
        </template>
      </ZD-list-querys>
      <div
        class="page-action-btns"
        style="display: flex;justify-content:space-between;align-items: center;"
      >
        <div style="display: flex;">
          <button class="common-bg-button" @click="handleExportFun()">
            导 出
          </button>
          <el-upload
            class="upload-demo"
            ref="upload"
            action="#"
            accept=".xlsx"
            :show-file-list="false"
            :on-preview="handlePreview"
            :http-request="handleImportFun"
          >
            <button class="common-bg-button">导 入</button>
          </el-upload>
        </div>

        <div>
          <button class="common-empty-button" @click="handleStation()">
            <b style="color:blue;">电站</b>展示模式
          </button>
          <button class="common-empty-button" @click="handleMeter()">
            <b style="color:green;">电表</b>展示模式
          </button>
        </div>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table
          :tableColumns="
            stationFlag ? pageConfig.stationListColumns : pageConfig.listColumns
          "
          :operates="operates"
          :tableData="stationFlag ? stationTableData : tableData"
          :tableConfig="pageConfig.tableConfig"
          :selections="selections"
          v-on:updateSelections="
            (sels) => {
              selections = sels;
            }
          "
        ></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
    </div>
    <!-- 导出结果框
    <el-dialog title="导入结果" :visible.sync="exportDialogVisible" width="20%">
      <span>
        导入成功 <b style="color:blue;">23</b>条，失败
        <b style="color:red;">7</b> 条，具体浏览【
        <a style="color:red;" href="javascript:;"><b>导出结果表</b> </a> 】
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      pagination: pageConfig.pagination,
      // exportDialogVisible: false,
      stationFlag: false,
      yearMon:'',
      tableData: [], // 表格数据
      stationTableData: [], // 表格数据
      selections: [], // 表格选项
      siteArr:[],
      stationName:'',
      queryInfo: {
        yearMon: "",
        elecName: "",
        stationName: "",
      },
      // 列操作按钮
      operates: {
        width: 220,
        fixed: "right",
        list: [],
      },
      pickerMinDate: "",
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.pickerMinDate = minDate.getTime();
          //如果选中结束时间,则小于所选当前时间
          if (maxDate) {
            this.pickerMinDate = "";
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate !== "") {
            let one = 30 * 24 * 3600 * 1000;
            let minTime = this.pickerMinDate - one;
            let maxTime = this.pickerMinDate + one;
            if (maxTime > new Date()) {
              maxTime = new Date();
            }
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
          return time.getTime() > Date.now();
        },
      },
    };
  },
  mounted() {
    
    this.getSite()
    this.yearMon = this.getMounth()
    this.queryInfo.yearMon = this.getMounth()
    this.getListData(this.pagination, true);
    console.log(this.getMounth());
  },
  methods: {
    stationNameChange(val){
      this.queryInfo.stationName = val
    },
    getSite() {
      let _ = this;
      let obj = {};
      obj.dealerNo = Array.from(new Set(_.dealNo)).join(",");
      obj.isHostOperate = _.queryInfo.isHostOperate;
      _.$H.post(_, _.$A.pileStation.listStationByDeal, obj).then((res) => {
        _.siteArr = res.data.data || [];
        _.siteArr.unshift({
          stationName:'全部电站'
        })
      });
    },
    getMounth(){
       //默认显示上月日期
     
        let date = new Date(new Date() - 30 * 24 * 3600 * 1000);
         let val =
            date.getFullYear() +'-'+
            (date.getMonth() + 1 < 10 ? "0" : "")+
            (date.getMonth() + 1);
            console.log(val);
        return val
      
    },
    monthChange(val){
      this.queryInfo.yearMon = val
      this.yearMon = val
    },
    handleStation() {
      this.stationFlag = true;
      this.getListData(this.pagination, true);
    },
    handleMeter() {
      this.stationFlag = false;
      this.getListData(this.pagination, true);
    },
    
    // 数据初始化
    getListData(pagination, reload = false) {
      let _ = this;
      if(_.stationName == '全部电站'){
        _.queryInfo.stationName = ''
      }
      if (_.stationFlag) {
        _.$U.showLoading(_);
        _.queryInfo.pageNum = pagination.current - 1;
        if (reload) {
          pagination.current = 1;
          _.queryInfo.pageNum = 0;
        }
        _.queryInfo.pageSize = pagination.pageSize;
        _.$H
          .post(_, _.$A.ammeterFeeRecord.pageByStation, _.queryInfo)
          .then((res) => {
            _.stationTableData = res.data.data.content || [];
            _.pagination.total = res.data.data.totalElements || 0;
            _.$U.hideLoading(_);
          });
      } else {
        _.$U.showLoading(_);
        _.queryInfo.pageNum = pagination.current - 1;
        if (reload) {
          pagination.current = 1;
          _.queryInfo.pageNum = 0;
        }
        _.queryInfo.pageSize = pagination.pageSize;
        _.$H.post(_, _.$A.ammeterFeeRecord.page, _.queryInfo).then((res) => {
          _.tableData = res.data.data.content || [];
          _.pagination.total = res.data.data.totalElements || 0;
          _.$U.hideLoading(_);
        });
      }
    },
    // 重置
    reset() {
      let _ = this;
      this.pagination.current = 1;
      _.queryInfo = {
        stationName: "",
        elecName: "",
        yearMon: "",
      };
      _.getListData(_.pagination, true);
    },
    // 电表导出
    handleExportFun() {
      let _ = this;
      if (_.stationFlag) {
        
        _.$U.showLoading(_);
        let params = {
          stationName: _.queryInfo.stationName,
          elecName: _.queryInfo.elecName,
          yearMon: _.queryInfo.yearMon,
        };
        _.$H
          .post(_, _.$A.ammeterFeeRecord.exportByStation2, params)
          .then((res) => {
            _.$U.hideLoading(_);
            let filePath = res.data.data.data;
            // let downUrl = "http://192.168.8.174:7999" + filePath; // 后台本地地址
            // let downUrl = "http://192.168.8.174:7999" + filePath; // 测试地址
            let downUrl = "http://ocharge.shzhida.com:6777" + filePath; // 正式地址
            window.open(downUrl, "_blank");
          });
      } else {
        _.$U.showLoading(_);
        let params = {
          stationName: _.queryInfo.stationName,
          elecName: _.queryInfo.elecName,
          yearMon: _.queryInfo.yearMon,
        };
        _.$H
          .post(_, _.$A.ammeterFeeRecord.pileTotalExport, params)
          .then((res) => {
            _.$U.hideLoading(_);
            let filePath = res.data.data.data;
            // let downUrl = "http://192.168.8.203:9000" + filePath; // 后台本地地址
            // let downUrl = "http://192.168.8.174:7999" + filePath; // 测试地址
            let downUrl = "http://ocharge.shzhida.com:6777" + filePath; // 正式地址
            window.open(downUrl, "_blank");
          });
      }
    },
    // 电表导入
    handleImportFun(file) {
      let _ = this;
      let form = new FormData();
      form.append("file", file.file);
      _.$H
        .postFormData(_, _.$A.ammeterFeeRecord.pileTotalImport2, form)
        .then((res) => {
          console.log(res.data.data);
          let filePath = res.data.data.data;
            // let downUrl = "http://192.168.8.203:9000" + filePath; // 后台本地地址
            // let downUrl = "http://192.168.8.174:7999" + filePath; // 测试地址
            let downUrl = "http://ocharge.shzhida.com:6777" + filePath; // 正式地址
            window.open(downUrl, "_blank");
            _.$message.success("导入成功");
            this.getListData(this.pagination, true);
          // if (res.data.data.flag) {
           
          // } else {
          //   // this.exportDialogVisible = true;
          //   _.$message.error(res.data.data.remark);
          // }
        });
    },
    handlePreview(file) {
      console.log(file);
    },
  },
};
</script>
